import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Components as NumberStepperComponents } from './NumberStepper.style';
import Box from '../Box';
import Hint from '../Hint';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
const NumberStepper = props => {
  const {
      className = 'numberStepper',
      label,
      disabled = false,
      hint,
      fit = 'medium',
      min = 0,
      max = 10,
      value,
      error,
      errorMessage,
      onChange
    } = props,
    rest = __rest(props, ["className", "label", "disabled", "hint", "fit", "min", "max", "value", "error", "errorMessage", "onChange"]);
  const [count, setCount] = useState('');
  const [disableMinus, setDisableMinus] = useState(false);
  const [disablePlus, setDisablePlus] = useState(false);
  const increment = () => {
    if (isNaN(parseInt(count))) {
      triggerOnChange(Math.max(min, 0).toString());
    } else {
      triggerOnChange(Math.max(min, parseInt(count) + 1).toString());
    }
  };
  const decrement = () => {
    if (isNaN(parseInt(count))) {
      triggerOnChange(Math.max(min, 0).toString());
    } else {
      triggerOnChange(Math.min(max, parseInt(count) - 1).toString());
    }
  };
  const triggerOnChange = val => {
    setCount(val);
    if (typeof onChange === 'function') {
      onChange(val);
    }
  };
  useEffect(() => {
    if (parseInt(count) <= min || parseInt(count) === 0) {
      setDisableMinus(true);
    } else if (parseInt(count) > min || parseInt(count) > 0) {
      setDisableMinus(false);
    }
    if (parseInt(count) >= max) {
      setDisablePlus(true);
    } else if (parseInt(count) < max) {
      setDisablePlus(false);
    }
  }, [count, min, max]);
  useEffect(() => {
    setCount(value || '');
  }, [value]);
  return _jsxs(NumberStepperComponents.Wrapper, _extends({
    className: className
  }, {
    children: [label && _jsx(Label, _extends({
      label: label,
      fit: fit,
      className: className
    }, rest)), _jsxs(Box, _extends({
      display: "flex"
    }, {
      children: [_jsx(NumberStepperComponents.ButtonElement, {
        className: "minusButton",
        variant: "outlined",
        label: "",
        icon: "minus",
        onClick: decrement,
        fit: fit,
        disabled: disabled ? disabled : disableMinus
      }), _jsx(NumberStepperComponents.InputElement, _extends({
        disabled: disabled,
        fit: fit,
        type: "number",
        errorMessage: "",
        error: error,
        onChange: e => onChange && onChange(e.target.value, e),
        value: value
      }, rest)), _jsx(NumberStepperComponents.ButtonElement, {
        className: "plusButton",
        variant: "outlined",
        label: "",
        icon: "plus",
        onClick: increment,
        fit: fit,
        disabled: disabled ? disabled : disablePlus
      })]
    })), error && _jsx(ErrorMessage, {
      fit: fit,
      errorMessage: errorMessage
    }), hint && _jsx(Hint, _extends({
      hint: hint,
      fit: fit
    }, rest))]
  }));
};
export default NumberStepper;